import { render, staticRenderFns } from "./WarehouseItem.vue?vue&type=template&id=656c447a&scoped=true&"
import script from "./WarehouseItem.vue?vue&type=script&lang=js&"
export * from "./WarehouseItem.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseItem.vue?vue&type=style&index=0&id=656c447a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656c447a",
  null
  
)

export default component.exports